import { apiRequest } from "./client";

/** What the complainant says is wrong; mirrors the API's `ContentReportCategory`. A claim, not a finding. */
export type ContentReportCategory = "Copyright" | "Trademark" | "Impersonation" | "Privacy" | "Other";

export type ContentReportPayload = {
	/** Id of the tree being reported, as the string the API serialises 64-bit ids to. */
	treeId: string;
	category: ContentReportCategory;
	/** How the complainant relates to the work: rights holder, agent, the person depicted. */
	claimedRelationship: string;
	/** What is wrong and where in the tree it appears. */
	details: string;
	/** The statement of good-faith belief a formal notice requires, in the complainant's own words. */
	goodFaithStatement: string;
	/** Anonymous submissions only — the API rejects these on an authenticated request, since it takes
	 * both from the account behind the token. */
	name?: string;
	email?: string;
	/** Honeypot — the field is hidden on the form, so only a bot ever fills it. The backend silently
	 * discards any submission that carries a value here. */
	website?: string;
};

/** Reports a published tree. Pass the access token when signed in so the backend links the report to
 * the account; anonymous submissions are accepted without one. */
export const submitContentReport = (payload: ContentReportPayload, token?: string | null): Promise<void> =>
	apiRequest<void>("/reports", { method: "POST", body: payload, token });
